module.exports = __webpack_public_path__ + "42d1531d6b42f7ce8fed1496121f0d17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.svg
// module id = 218
// module chunks = 12